import { render, staticRenderFns } from "./adv-img-edit.vue?vue&type=template&id=55af3653&scoped=true"
import script from "./adv-img-edit.vue?vue&type=script&lang=js"
export * from "./adv-img-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55af3653",
  null
  
)

export default component.exports